import './backend/mock-data';
import './system.mockup';
import './backend.mock';

import './backend/catering.mock';

export * from './system.mockup';
